import { graphql, useFragment } from "react-relay";
import {
  RewardKind,
  RewardsFragment$key,
} from "./__generated__/RewardsFragment.graphql";
import { assertNever } from "@/utils/helpers";

function rewardEmoji(kind: RewardKind) {
  switch (kind) {
    case "BADGE":
      return "🏆";
    case "LEARNING":
      return "🎖️";
    case "MONEY":
      return "💰";
    case "SWAG":
      return "😎";
    default:
      assertNever(kind);
  }
}

const Fragment = graphql`
  fragment RewardsFragment on Rewardable {
    rewards {
      nodes {
        id
        kind
        description
      }
    }
  }
`;

interface Props {
  activity: RewardsFragment$key;
}

export function Rewards(props: Props) {
  const {
    rewards: { nodes: rewards },
  } = useFragment(Fragment, props.activity);

  return (
    <ul className="list-disc pl-5 flex flex-col gap-1.5">
      {rewards.map((reward) => (
        <li
          key={reward.id}
          className="text-base font-normal text-grey-700 leading-6"
        >
          {rewardEmoji(reward.kind)} {reward.description}
        </li>
      ))}
    </ul>
  );
}
